import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito experiencia previa con plantas medicinales?',
    answer: 'No. El libro está diseñado desde cero para personas sin ningún conocimiento previo. Cada receta tiene instrucciones claras y paso a paso, con los errores más comunes señalados para que no los cometas.'
  }, {
    question: '¿Los ingredientes son difíciles de conseguir?',
    answer: 'No. El 95% son básicos de cocina — ajo, jengibre, cúrcuma, limón, canela, hinojo. Los encontrarás en cualquier supermercado o mercado local sin importar en qué país estés.'
  }, {
    question: '¿Puedo usarlo si tomo medicamentos?',
    answer: 'El Módulo de Seguridad incluye las interacciones más importantes, especialmente con anticoagulantes como la Warfarina y medicamentos para la diabetes. Siempre recomendamos informar a tu médico antes de iniciar cualquier protocolo natural.'
  }, {
    question: '¿En qué formato viene y cómo lo recibo?',
    answer: 'Es un PDF de alta resolución optimizado para cualquier dispositivo — teléfono, tablet, iPad o computadora. Lo recibirás por correo electrónico de forma inmediata tras confirmar tu pago. No necesitas ninguna aplicación especial.'
  }, {
    question: '¿Y si no funciona para mí?',
    answer: 'Tienes 60 días para probarlo. Si no sientes ninguna diferencia o simplemente decides que no es lo que esperabas, te devolvemos tu dinero al completo. Sin preguntas y sin complicaciones.'
  }];
  return <section ref={ref} className="py-10 md:py-16 px-4 bg-white" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-33">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-warm-brown mb-8 md:mb-12 text-center px-2" data-id="element-34">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-3 md:space-y-4" data-id="element-35">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-cream rounded-lg border-2 border-sage-light overflow-hidden" data-id="element-36">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 text-left hover:bg-sage-light/20 transition-colors" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-37">
                  <span className="font-heading text-base md:text-lg lg:text-xl text-gray-900 pr-3 md:pr-4" data-id="element-38">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 md:w-6 md:h-6 text-sage flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-39" />
                </button>
                <AnimatePresence data-id="element-40">
                  {openIndex === index && <motion.div id={`faq-answer-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-41">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 text-gray-700 text-sm md:text-base" data-id="element-42">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}